import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../ui/command';
import { ChevronsUpDown, Check } from 'lucide-react';

// options: [{ key, label, sublabel, group, search }]
export const SearchPicker = ({ options, value, onSelect, placeholder, searchPlaceholder, emptyText = 'No matches', testId, clearLabel }) => {
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState('');
  const selected = options.find((o) => o.key === value);
  const groups = React.useMemo(() => {
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    const map = new Map();
    options.forEach((o) => {
      const hay = (o.search || o.label).toLowerCase();
      if (!words.every((w) => hay.includes(w))) return;
      const g = o.group || ''; if (!map.has(g)) map.set(g, []); map.get(g).push(o);
    });
    return [...map.entries()];
  }, [options, query]);

  const choose = (key) => { onSelect(key); setOpen(false); setQuery(''); };

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (!v) setQuery(''); }}>
      <PopoverTrigger asChild>
        <button type="button" className="w-full border rounded-md h-9 px-2 text-sm bg-white flex items-center justify-between gap-2 text-left hover:border-teal-400 transition-colors" data-testid={testId}>
          <span className={`truncate ${selected ? 'text-slate-900' : 'text-slate-500'}`}>{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 w-[min(92vw,420px)]" data-testid={`${testId}-popover`}>
        <Command shouldFilter={false}>
          <CommandInput value={query} onValueChange={setQuery} placeholder={searchPlaceholder} className="text-base sm:text-sm" data-testid={`${testId}-search`} />
          <CommandList className="max-h-[50vh]">
            <CommandEmpty>{emptyText}</CommandEmpty>
            {clearLabel && !query && (
              <CommandGroup>
                <CommandItem value="__clear__" onSelect={() => choose('')} data-testid={`${testId}-clear`}>{clearLabel}</CommandItem>
              </CommandGroup>
            )}
            {groups.map(([g, opts]) => (
              <CommandGroup key={g || 'all'} heading={g || undefined}>
                {opts.map((o) => (
                  <CommandItem key={o.key} value={o.key} onSelect={() => choose(o.key)} className="py-2" data-testid={`${testId}-option`}>
                    <Check className={`h-4 w-4 mr-2 shrink-0 ${o.key === value ? 'opacity-100 text-teal-600' : 'opacity-0'}`} />
                    <div className="min-w-0">
                      <div className="truncate">{o.label}</div>
                      {o.sublabel && <div className="truncate text-xs opacity-75">{o.sublabel}</div>}
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
